var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-overlay',{attrs:{"z-index":"10000","show":_vm.popShow}},[_c('div',{staticClass:"wrapper",style:({paddingTop:(_vm.height/2-50)+'px'}),on:{"click":function($event){$event.stopPropagation();}}},[_c('van-loading',{attrs:{"type":"spinner","size":"100px"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }